import {safeGet} from '../../utils/safeGet'
import {generateTableColumn} from '../../creator/common/vnode/table'
import Pagination from '../../creator/common/vnode/pagination.js'

export default {
  name: 'SpTableSelect',
  render(h) {
    const tableChildren = []
    if (!this.hideSelection) {
      tableChildren.push(h('el-table-column', {
        props: {
          type: 'selection',
          width: '55',
          'reserve-selection': true,
          selectable: this.filterSelectable
        },
      }))
    }
    tableChildren.push(generateTableColumn(this, h))
    const paginationChild = this.hidePagination ? null : Pagination(this, h)
    return (
      <div>
        <el-table
          data={this.tableData.data}
          ref='multipleTable'
          rowKey={(row) => row[this.tableSelectKey]}
          on-selection-change={this.handleSelectionChange}
          border={true}
          stripe={true}
        >
          {tableChildren}
        </el-table>
        {paginationChild}
      </div>
    )
  },
  props: {
    'items': {
      required: true
    },
    'tableSchema': {
      type: Array
    },
    'tableSelectKey': {
      default: 'id'
    },
    'beforeCreateOptions': {
      type: Function
    },
    'hidePagination': {
      type: Boolean,
      default: false
    },
    'getTableList': {
      type: Function
    },
    'filterSelectable': {
      type: Function
    },
    'hideSelection': {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      pageSize: 10,
      pageSizes: [10, 20],
      paginationLayout: 'total, sizes, prev, pager, next',
      currentPage: 1
    }
  },
  watch: {
    items(items) {
      this.updateItems(items)
    }
  },
  created() {
    if (typeof this.items === 'string') {
      try {
        this.$watch(() => {
          return safeGet(this.$store.state, this.items)
        }, (val) => {
          let options = (this.getTableList && typeof this.getTableList === 'function') ? this.getTableList(val, this.pageSize, this.currentPage) : val
          this.updateItems(options)
        }, {
          immediate: true
        })
      } catch (e) {
        console.log(e)
        throw new Error('bad select options')
      }
    } else {
      this.updateItems(this.items)
    }
  },
  methods: {
    updateItems(items) {
      // console.log('updateItems', items)
      if (Object.prototype.toString.call(items) === '[object Promise]') {
        this.tableData = {
          data: [],
          totel: 0
        }
        items.then(data => {
          this.tableData = data
        }).catch(() => {})
      } else if (typeof items === 'function') {
        this.tableData = items(this.$store.state)
      } else {
        this.tableData = items
      }
    },
    handleSizeChange(size) {
      this.getTableList(safeGet(this.$store.state, this.items), size, 1)
      this.currentPage = 1
      this.pageSize = size
    },
    handleCurrentChange(page) {
      this.getTableList(safeGet(this.$store.state, this.items), this.pageSize, page)
      this.currentPage = page
    },
    handleSelectionChange(val) {
      this.$emit('selectionChange', val)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/components/Forms/SpTableSelect.js